export default {
  items: [
    {
      icon: "bubble_chart",
      title: "Business",
      route: "create-company",
      order: 1,
    },
    {
      icon: "bubble_chart",
      title: "Auth Rep",
      route: "create-customer",
      order: 2,
    },
    {
      icon: "contacts",
      title: "Guarantor",
      route: "create-contacts",
      order: 3,
    },
    {
      icon: "attach_money",
      title: "Direct Debit",
      route: "direct-debit",
      order: 4,
    },
    // {
    //   icon: "bubble_chart",
    //   title: "Residential",
    //   route: "create-customer",
    //   order: 5
    // },

    {
      icon: "swap_horizontal_circle",
      title: "Change Lessee",
      route: "change-lessee",
      order: 18,
    },
    {
      icon: "bubble_chart",
      title: "Fixed Line",
      route: "create-pstn",
      order: 6,
    },
    {
      icon: "bubble_chart",
      title: "IP Voice",
      route: "create-ipvoice",
      order: 7,
    },
    {
      icon: "bubble_chart",
      title: "SIP",
      route: "create-sip",
      order: 8,
    },
    {
      icon: "bubble_chart",
      title: "IP Porting",
      route: "create-porting",
      order: 9,
    },
    {
      icon: "bubble_chart",
      title: "Internet",
      route: "create-internet",
      order: 10,
    },
    {
      icon: "bubble_chart",
      title: "Mobile",
      route: "create-mobile",
      order: 11,
    },
    {
      icon: "bubble_chart",
      title: "Inbound",
      route: "create-inbound",
      order: 12,
    },
    {
      icon: "bubble_chart",
      title: "Hardware",
      route: "create-hardware/false",
      order: 13,
    },
    {
      icon: "bubble_chart",
      title: "Fax",
      route: "create-fax",
      order: 14,
    },
    {
      icon: "bubble_chart",
      title: "Call Management Console",
      route: "create-cmc",
      order: 15,
    },
    // {
    //   icon: "bubble_chart",
    //   title: "Finance",
    //   route: "create-finance",
    //   order: 16
    // },
    {
      icon: "bubble_chart",
      title: "Attachments",
      route: "attachments",
      order: 17,
    },
    {
      icon: "attach_money",
      title: "Finance Application",
      route: "create-finance",
      order: 19,
    },
    // {
    //   icon: "bubble_chart",
    //   title: "Sign and Send",
    //   route: "order-summary",
    //   order: 20
    // }
  ],
};
